/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var StoreAvailabilityStatusReason;
(function (StoreAvailabilityStatusReason) {
    StoreAvailabilityStatusReason["OUT_OF_MENU_HOURS"] = "out_of_menu_hours";
    StoreAvailabilityStatusReason["PAUSED_BY_PLATFORM"] = "paused_by_platform";
    StoreAvailabilityStatusReason["PAUSED_BY_RESTAURANT"] = "paused_by_restaurant";
    StoreAvailabilityStatusReason["OFFLINE"] = "offline";
    StoreAvailabilityStatusReason["ACTIVE"] = "active";
    StoreAvailabilityStatusReason["ONBOARDING"] = "onboarding";
    StoreAvailabilityStatusReason["UNKNOWN"] = "unknown";
    StoreAvailabilityStatusReason["RESTAURANT_SYSTEM_OUTAGE"] = "restaurant_system_outage";
})(StoreAvailabilityStatusReason || (StoreAvailabilityStatusReason = {}));
